import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import { ProductService } from "../../services/product.service";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import * as _ from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { StbCustomRenderNumberComponent } from "../smart-table-customs/custom-render-number";

import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DOUBLE_PATTERN } from "../../@auth/components/constants";
import { FinanceService } from "../../services/finance.service";

import Shop from "../../models/shop.model";
import { Supplier } from "../../models/supplier.model";
import { DialogDeptSupplierComponent } from "../dialog-dept-supplier/dialog-dept-supplier.component";

@Component({
  selector: "ngx-view-table-suppliers",
  styleUrls: ["./view-table-suppliers.component.scss"],
  templateUrl: "./view-table-suppliers.component.html",
})
export class ViewTableSuppliersComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() shop?: Shop;
  @Input() source: LocalDataSource = new LocalDataSource();
  @Input() suppliers?: Supplier[] = [];

  @Output() onSelectedItem: EventEmitter<any> = new EventEmitter();
  @Output() onChangeData: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  isEditing = false;

  uid = "anonymous";
  user: User;

  //ng2-smart-table config
  settings = {};

  constructor(
    private userService: UserService,
    private dialogService: NbDialogService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.user = user;
          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }

          this.settings = {
            hideHeader: false,
            noDataMessage:
              user.language == "en" ? "Empty data" : "Không có dữ liệu",
            attr: {
              class: "table table-striped",
            },
            actions: {
              columnTitle: "",
              add: false,
              edit: false,
              delete: false,
            },
            columns: {
              fullName: {
                title: "Nhà cung cấp",
                type: "string",
              },
              mobile: {
                title: "Điện thoại",
                type: "string",
              },
              saleAmount: {
                title: "Doanh thu",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              paidAmount: {
                title: "Thanh toán",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              debitAmount: {
                title: "Còn nợ",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
            },
          };
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //smart-table events
  selectedItem(event): void {
    const item = event.data;
    this.onSelectedItem.emit(item);

    let itemMore = _.clone(item);
    this.dialogService
      .open(DialogDeptSupplierComponent, {
        context: {
          shopId: this.shopId,
          uid: this.uid,
          user: this.user,
          shop: this.shop,
          supplier: itemMore,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value: Supplier) => {
        if (value) {
          if (
            item.saleQuantity != value.saleQuantity ||
            item.saleAmount != value.saleAmount ||
            item.paidAmount != value.paidAmount ||
            item.debitAmount != value.debitAmount ||
            item.profitAmount != value.profitAmount
          ) {
            item.saleQuantity = value.saleQuantity;
            item.saleAmount = value.saleAmount;
            item.paidAmount = value.paidAmount;
            item.debitAmount = value.debitAmount;
            item.profitAmount = value.profitAmount;

            _.forEach(this.suppliers, (item) => {
              if (item.id === value.id) {
                item.saleAmount = value.saleAmount;
                item.paidAmount = value.paidAmount;
                item.debitAmount = value.debitAmount;
                item.isSynced = true;
                this.onChangeData.emit(true);
              }
            });

            this.source.load(this.suppliers);
          }
        }
      });
  }
}
